export default __webpack_public_path__ + "static/media/work_life_balance.aab4d076.svg";